import React from 'react';
import { Typography as EcoTypography } from "@bsw/react-nightingale";

export const Typography=(props) =>{
    return <EcoTypography {...props} />;
}


